import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  searchActive: boolean = false;
  seachKeyword: string;

  aboutKcentra: boolean = true;
  whyKcentra: boolean = true;
  dosingAdministrator: boolean = true;
  orderingReimbursement: boolean = true;

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
  }


  searchbar() {
    if (this.searchActive == true)
      this.searchActive = false;
    else
      this.searchActive = true;
  }
}

